import { inject as r, computed as t } from "vue";
import { createLocale as c } from "./highrise309.mjs";
function s(o) {
  const e = r("mergedLanguageLocale", null) || {}, l = c("en-US");
  return t(() => {
    var a;
    return ((a = e == null ? void 0 : e.value) == null ? void 0 : a[o]) ?? l[o];
  });
}
export {
  s as default
};
